import { Guid } from 'guid-typescript';

export interface IChangeTracking {
  editDateUtc: Date | null;
  syncDateUtc: Date | null;
}

export class ChangeTracking implements IChangeTracking {
  editDateUtc!: Date;
  syncDateUtc: Date | null = null;
  trackingGuid: string = Guid.create().toString();
}
